import { render, staticRenderFns } from "./ArrivalPhoto.vue?vue&type=template&id=f28ce928&scoped=true&"
import script from "./ArrivalPhoto.vue?vue&type=script&lang=js&"
export * from "./ArrivalPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalPhoto.vue?vue&type=style&index=0&id=f28ce928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28ce928",
  null
  
)

export default component.exports